import { header } from "@wordpress/icons";

jQuery(document).ready(function ($) {
  // ─── Hamburger / slide-in panel ────────────────────────────────────────────

  const $blocks = $(".wp-block-jormi-blocks-custom-menu");

  if ($blocks.length) {
    $blocks.each(function () {
      const $block = $(this);
      const $menuPanel = $block.find("[data-menu-panel]");
      const $menuTrigger = $block.find("[data-menu-trigger]");

      let menuTl;
      let accordionInited = false;

      if (typeof gsap !== "undefined" && $menuPanel.length) {
        gsap.set($menuPanel[0], {
          yPercent: -100,
          opacity: 0,
          visibility: "hidden",
        });

        menuTl = gsap.timeline({
          paused: true,
          defaults: { duration: 0.8, ease: "expo.inOut" },
        });

        menuTl.to($menuPanel[0], {
          yPercent: 0,
          opacity: 1,
          visibility: "visible",
        });
      }

      function initAccordion() {
        // Preline can't measure heights inside hidden elements.
        // Re-init after the panel is visible so scrollHeight is accurate.
        if (!accordionInited && typeof window.HSAccordion !== "undefined") {
          window.HSAccordion.autoInit();
          accordionInited = true;
        }
      }

      function closeMenu() {
        if (typeof gsap !== "undefined" && menuTl) {
          menuTl.reverse();
          menuTl.eventCallback("onReverseComplete", function () {
            $menuPanel.addClass("invisible hidden");
          });
        } else {
          $menuPanel.addClass("invisible hidden");
        }
        $("html").css("overflowY", "auto");
        $menuTrigger.attr("aria-expanded", "false");
      }

      if ($menuTrigger.length && $menuPanel.length) {
        $menuTrigger.on("click", function () {
          const isExpanded = $(this).attr("aria-expanded") === "true";

          if (!isExpanded) {
            $menuPanel.removeClass("invisible hidden");

            if (typeof gsap !== "undefined" && menuTl) {
              menuTl.play();
            }

            $menuTrigger.css({ zIndex: 999, position: "absolute" });
            $("html").css("overflowY", "hidden");
            $menuTrigger.attr("aria-expanded", "true");

            // Init Preline accordion now that the panel is in the DOM and visible
            initAccordion();
          } else {
            closeMenu();
          }
        });

        $menuPanel.on("click", "a", function () {
          if (this.hash) closeMenu();
        });
      }
    });
  }

  // ─── Desktop dropdown nav ──────────────────────────────────────────────────

  const $desktopNavs = $("[data-desktop-nav]");

  if (!$desktopNavs.length) return;

  function openDropdown($dropdown) {
    const $trigger = $dropdown.find("[data-dropdown-trigger]");
    const $panel = $dropdown.find("[data-dropdown-panel]");
    $trigger.attr("aria-expanded", "true");
    $panel
      .removeClass("hidden opacity-0 translate-y-1")
      .addClass("opacity-100 translate-y-0");
    $trigger.find("svg").addClass("rotate-180");
  }

  function closeDropdown($dropdown) {
    const $trigger = $dropdown.find("[data-dropdown-trigger]");
    const $panel = $dropdown.find("[data-dropdown-panel]");
    $trigger.attr("aria-expanded", "false");
    $panel
      .removeClass("opacity-100 translate-y-0")
      .addClass("opacity-0 translate-y-1");
    setTimeout(function () {
      if ($trigger.attr("aria-expanded") === "false") {
        $panel.addClass("hidden");
      }
    }, 200);
    $trigger.find("svg").removeClass("rotate-180");
  }

  function closeAllDropdowns($scope) {
    ($scope || $desktopNavs).find("[data-dropdown]").each(function () {
      closeDropdown($(this));
    });
  }

  $desktopNavs.on("click", "[data-dropdown-trigger]", function (e) {
    e.stopPropagation();
    const $dropdown = $(this).closest("[data-dropdown]");
    const isOpen = $(this).attr("aria-expanded") === "true";
    $(this)
      .closest("[data-desktop-nav]")
      .find("[data-dropdown]")
      .not($dropdown)
      .each(function () {
        closeDropdown($(this));
      });
    isOpen ? closeDropdown($dropdown) : openDropdown($dropdown);
  });

  $(document).on("click.desktopNav", function (e) {
    if (!$(e.target).closest("[data-desktop-nav]").length) closeAllDropdowns();
  });

  $(document).on("keydown.desktopNav", function (e) {
    if (e.key !== "Escape") return;
    $desktopNavs.find("[data-dropdown]").each(function () {
      const $dd = $(this);
      if (
        $dd.find("[data-dropdown-trigger]").attr("aria-expanded") === "true"
      ) {
        closeDropdown($dd);
        $dd.find("[data-dropdown-trigger]").trigger("focus");
      }
    });
  });

  $desktopNavs.on("keydown", "[data-dropdown-panel] a", function (e) {
    const $links = $(this).closest("[data-dropdown-panel]").find("a");
    const index = $links.index(this);
    if (e.key === "ArrowDown") {
      e.preventDefault();
      $links.eq(index + 1).trigger("focus");
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      index === 0
        ? $(this)
            .closest("[data-dropdown]")
            .find("[data-dropdown-trigger]")
            .trigger("focus")
        : $links.eq(index - 1).trigger("focus");
    }
  });

  $desktopNavs.on("keydown", "[data-dropdown-trigger]", function (e) {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const $dropdown = $(this).closest("[data-dropdown]");
      openDropdown($dropdown);
      $dropdown.find("[data-dropdown-panel] a").first().trigger("focus");
    }
  });
});

const button = document.querySelector(".jormi-menu__trigger-icons");
const siteHeader = document.querySelector(".site-header");
let isMenuOpen = false;

button.addEventListener("click", () => {
  const svg = button.querySelector(".icon-close");
  const scrollPos = window.pageYOffset;
  isMenuOpen = !isMenuOpen;

  svg.style.fill = "black";

  if (isMenuOpen) {
  } else if (scrollPos > 800) {
    siteHeader.classList.add("header-scrolled");
  } else {
    siteHeader.classList.remove("header-scrolled");
  }
});

document.addEventListener("scroll", () => requestAnimationFrame(scroller));

function scroller() {
  let scrollPos = window.pageYOffset;

  if (scrollPos > 800) {
    siteHeader.classList.add("header-scrolled");
  } else {
    siteHeader.classList.remove("header-scrolled");
  }
}

// contact page styles
document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname === "/contact/") {
    siteHeader.classList.add("contact-header");
  } else {
    siteHeader.classList.remove("contact-header");
  }
});
